import { Controller } from "@hotwired/stimulus";
import Shepherd from "shepherd.js";

// Walks an account without a linked Google login towards linking one: from the dashboard to its
// own page, then to the Google button there. Each step shows at most once a day per account, as
// pupils share school computers.
export default class extends Controller {
  static values = { user: String, step: String };

  connect() {
    const key = `googleLinkTourShownOn:${this.stepValue}:${this.userValue}`;
    const today = new Date().toDateString();
    if (readItem(key) === today) return;

    this.tour = STEPS[this.stepValue]();
    this.tour.start();
    writeItem(key, today);
  }

  disconnect() {
    if (this.tour?.isActive()) this.tour.cancel();
  }
}

// Storage can be blocked outright, which reads as never shown
function readItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // The tour then shows on every visit, as it would with no storage at all
  }
}

function buildNameTour() {
  const tour = new Shepherd.Tour({ useModalOverlay: true });

  // The name link is inside the collapsed menu on a narrow screen
  if (document.getElementById("current_user").offsetParent === null) {
    tour.addStep({
      id: "Click Menu",
      text: "To get started, click here to expand the menu",
      attachTo: { element: ".navbar-toggler", on: "bottom" },
      buttons: [
        { text: "Next", action: tour.next },
        { text: "Later", action: tour.cancel },
      ],
    });
  }

  tour.addStep({
    id: "Link to Google",
    text: "Let's get your account linked to Google, so you don't have to remember another username and password! Click on your name",
    attachTo: { element: "#current_user", on: "bottom" },
    buttons: [{ text: "Later", action: tour.cancel }],
  });

  return tour;
}

function buildSignInTour() {
  const tour = new Shepherd.Tour({ useModalOverlay: true });

  tour.addStep({
    id: "Click Login Google",
    text: "Click on this button, login and you're done!",
    attachTo: { element: "#loginGoogle", on: "bottom" },
    buttons: [{ text: "Later", action: tour.cancel }],
  });

  return tour;
}

// The step values the views render: "name" on the dashboards, "sign-in" on the user page
const STEPS = { name: buildNameTour, "sign-in": buildSignInTour };
